module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("下拉列表 <uk-dropdown-list>")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("下拉列表是一个带有下拉数据列表的容器组件，你可以在默认插槽内放置任何可被点击的组件")]), _vm._v(" "), _c('uk-dropdown-list', {
    attrs: {
      "items": [{
          label: '选项1',
          value: 'item1'
        },
        {
          label: '选项2',
          value: 'item2'
        },
        {
          label: '选项3',
          value: 'item3'
        },
        {
          label: '选项4',
          value: 'item4'
        },
        {
          label: '选项5',
          value: 'item5'
        },
        {
          label: '选项6',
          value: 'item6'
        },
        {
          label: '选项7',
          value: 'item7'
        }
      ]
    }
  }, [_c('uk-button', {
    attrs: {
      "right-icon": "caret-down"
    }
  }, [_vm._v("下拉")])], 1), _vm._v(" "), _c('code-block', [_vm._v(_vm._s(_vm.usages.basic))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38a07a24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/docs/UkDropdown.doc.vue
// module id = 285
// module chunks = 2